/**
 * Days from `from` (inclusive) until the next occurrence of birthday
 * "YYYY-MM-DD". Ignores leap-day edge case: Feb 29 → treated as Mar 1.
 */
export function daysUntilBirthday(birthday: string, from: Date = new Date()): number {
  const [, mStr, dStr] = birthday.split("-");
  const month = Number(mStr);
  const day = Number(dStr);
  const base = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  let next = new Date(from.getFullYear(), month - 1, day);
  if (next < base) next = new Date(from.getFullYear() + 1, month - 1, day);
  return Math.round((next.getTime() - base.getTime()) / 86_400_000);
}
